<template>
  <span
    v-if="previous !== null && previous !== undefined && !isNaN(previous)"
    class="variation-chip"
    :class="kind"
  >
    <svg
      v-if="kind === 'up'"
      class="variation-chip-icon"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M12 4 L21 19 L3 19 Z" />
    </svg>
    <svg
      v-else-if="kind === 'down'"
      class="variation-chip-icon"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M12 20 L3 5 L21 5 Z" />
    </svg>
    <svg
      v-else
      class="variation-chip-icon"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="5" fill="currentColor" />
    </svg>
    <span class="variation-chip-value">{{ deltaFormatted }} pts</span>
    <span v-if="label" class="variation-chip-note">{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: "VariationChip",

  props: {
    current: {
      type: Number,
      required: true,
    },

    previous: {
      type: Number,
      default: null,
    },

    label: {
      type: String,
      default: "",
    },

    size: {
      type: Number,
      default: 13,
    },
  },

  computed: {
    delta() {
      return this.current - this.previous;
    },

    kind() {
      if (this.delta >= 10) return "up";
      if (this.delta <= -10) return "down";
      return "stable";
    },

    deltaFormatted() {
      const sign = this.delta > 0 ? "+" : "";
      return `${sign}${this.delta.toFixed(1).replace(".", ",")}`;
    },
  },
};
</script>

<style scoped>
.variation-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  font-weight: 700;
  background: #ffffff7a;
  border-radius: 5px;
  padding: 3px 8px;
  white-space: nowrap;
  min-width: 0;
}

.variation-chip-icon {
  flex: none;
}

.variation-chip.up {
  color: #0cc100;
}

.variation-chip.down {
  color: #c10000;
}

.variation-chip.stable {
  color: #7a7a7a;
}

.variation-chip-value {
  min-width: 34px;
  text-align: right;
}

.variation-chip-note {
  font-weight: 500;
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/variationChip.vue